import { SpecificFilterRow } from 'modules/search/types';
import { AutocompleteOption, Filter } from 'types';
import { relationOptionsOptions } from 'modules/search/v2/specificFilterRows/relation-options';
import { ParamsMap } from '../search-v3-types';
import { getEmptyParamsMap, getNegationFilter } from '../search-v3-utils';

// TODO: refactor

export const formatRegisterClassAndLabelFilter = (
  row: SpecificFilterRow
): ParamsMap | undefined => {
  if (!!!row?.customFilterValues?.[1]?.value) {
    return undefined;
  }

  // TODO: presunut do definicii
  const getFieldValue = (option: AutocompleteOption): string =>
    option?.id ?? '';

  //TODO: zbavit sa magic numbers
  const registerItemPreferredName = getFieldValue(
    row.customFilterValues?.[1]?.value
  );

  const paramsMap = getEmptyParamsMap();

  const eadNodeUnitFilters: Filter[] = [];

  eadNodeUnitFilters.push({
    operation: 'OR',
    filters: [
      {
        operation: 'CONTAINS',
        field: 'relations.originator.label',
        value: registerItemPreferredName,
        nestedQueryEnabled: false,
      },
      {
        operation: 'CONTAINS',
        field: 'eadNode.relations.originator.label',
        value: registerItemPreferredName,
        nestedQueryEnabled: false,
      },
    ],
  });

  eadNodeUnitFilters.push({
    operation: 'CONTAINS',
    field: 'originator.label',
    value: registerItemPreferredName,
  });

  eadNodeUnitFilters.push({
    operation: 'OR',
    filters: [
      {
        operation: 'NESTED',
        path: 'relations',
        filter: {
          operation: 'AND',
          filters: [
            {
              operation: 'CONTAINS',
              field: 'relations.originator.label',
              value: registerItemPreferredName,
            },
            {
              operation: 'EQ',
              field: 'relations.label',
              value: 'autorské dílo',
            },
          ],
        },
      },
      {
        operation: 'NESTED',
        path: 'eadNode.relations',
        filter: {
          operation: 'AND',
          filters: [
            {
              operation: 'CONTAINS',
              field: 'eadNode.relations.originator.label',
              value: registerItemPreferredName,
              nestedQueryEnabled: false,
            },
            {
              operation: 'EQ',
              field: 'eadNode.relations.label',
              value: 'autorské dílo',
              nestedQueryEnabled: false,
            },
          ],
        },
      },
    ],
  });

  paramsMap.EAD_NODE_UNIT?.push(
    getNegationFilter(
      { operation: 'OR', filters: eadNodeUnitFilters },
      !!row.negation
    )
  );

  paramsMap.ARCHIVAL_COLLECTION?.push(
    getNegationFilter(
      {
        operation: 'CONTAINS',
        field: 'originators.label',
        value: registerItemPreferredName,
      },
      !!row.negation
    )
  );
  paramsMap.ARCHIVAL_AID?.push(
    getNegationFilter(
      {
        operation: 'CONTAINS',
        field: 'search.label',
        value: registerItemPreferredName,
      },
      !!row.negation
    )
  );

  return paramsMap;
};

export const formatRegisterClassAndLabelFilter__NEW = (
  row: SpecificFilterRow
): ParamsMap | undefined => {
  if (!!!row?.customFilterValues?.[1]?.value) {
    return undefined;
  }

  // TODO: presunut do definicii
  const getFieldValue = (option: AutocompleteOption): string =>
    option?.id ?? '';

  //TODO: zbavit sa magic numbers
  const registerItemPreferredName = getFieldValue(
    row.customFilterValues?.[1]?.value
  );

  const paramsMap = getEmptyParamsMap();

  paramsMap.EAD_NODE_UNIT?.push(
    getNegationFilter(
      {
        operation: 'CONTAINS',
        field: 'originator.label',
        value: registerItemPreferredName,
      },
      !!row.negation
    )
  );

  paramsMap.ARCHIVAL_COLLECTION?.push(
    getNegationFilter(
      {
        operation: 'CONTAINS',
        field: 'originators.label',
        value: registerItemPreferredName,
      },
      !!row.negation
    )
  );
  paramsMap.ARCHIVAL_AID?.push(
    getNegationFilter(
      {
        operation: 'CONTAINS',
        field: 'search.label',
        value: registerItemPreferredName,
      },
      !!row.negation
    )
  );

  return paramsMap;
};

export const formatRegisterClassAndLabelFilterEadNodeUnitOriginator = (
  row: SpecificFilterRow
): ParamsMap | undefined => {
  if (!!!row?.customFilterValues?.[1]?.value) {
    return undefined;
  }

  // TODO: presunut do definicii
  const getFieldValue = (option: AutocompleteOption): string =>
    option?.id ?? '';

  //TODO: zbavit sa magic numbers
  const registerItemPreferredName = getFieldValue(
    row.customFilterValues?.[1]?.value
  );

  const paramsMap = getEmptyParamsMap();

  paramsMap.EAD_NODE_UNIT?.push(
    getNegationFilter(
      {
        operation: 'CONTAINS',
        field: 'originator.label',
        value: registerItemPreferredName,
      },
      !!row.negation
    )
  );

  return paramsMap;
};

export const formatRegisterClassAndLabelFilterCollectionOriginator = (
  row: SpecificFilterRow
): ParamsMap | undefined => {
  if (!!!row?.customFilterValues?.[1]?.value) {
    return undefined;
  }

  // TODO: presunut do definicii
  const getFieldValue = (option: AutocompleteOption): string =>
    option?.id ?? '';

  //TODO: zbavit sa magic numbers
  const registerItemPreferredName = getFieldValue(
    row.customFilterValues?.[1]?.value
  );

  const paramsMap = getEmptyParamsMap();

  paramsMap.ARCHIVAL_COLLECTION?.push(
    getNegationFilter(
      {
        operation: 'CONTAINS',
        field: 'originators.label',
        value: registerItemPreferredName,
      },
      !!row.negation
    )
  );
  return paramsMap;
};

export const formatRegisterClassAndLabelFilterArchivalAidOriginator = (
  row: SpecificFilterRow
): ParamsMap | undefined => {
  if (!!!row?.customFilterValues?.[1]?.value) {
    return undefined;
  }

  // TODO: presunut do definicii
  const getFieldValue = (option: AutocompleteOption): string =>
    option?.id ?? '';

  //TODO: zbavit sa magic numbers
  const registerItemPreferredName = getFieldValue(
    row.customFilterValues?.[1]?.value
  );

  const paramsMap = getEmptyParamsMap();

  paramsMap.ARCHIVAL_AID?.push(
    getNegationFilter(
      {
        operation: 'CONTAINS',
        field: 'originators.label',
        value: registerItemPreferredName,
      },
      !!row.negation
    )
  );
  return paramsMap;
};

export const formatRegisterClassAndLabelFilterArchivalAidAuthor = (
  row: SpecificFilterRow
): ParamsMap | undefined => {
  if (!!!row?.customFilterValues?.[1]?.value) {
    return undefined;
  }

  // TODO: presunut do definicii
  const getFieldValue = (option: AutocompleteOption): string =>
    option?.id ?? '';

  //TODO: zbavit sa magic numbers
  const registerItemPreferredName = getFieldValue(
    row.customFilterValues?.[1]?.value
  );

  const paramsMap = getEmptyParamsMap();

  paramsMap.ARCHIVAL_AID?.push(
    getNegationFilter(
      {
        operation: 'CONTAINS',
        field: 'authors.labels',
        value: registerItemPreferredName,
      },
      !!row.negation
    )
  );
  return paramsMap;
};

export const formatRegisterClassAndLabelRelationsFilters = (
  row: SpecificFilterRow
): ParamsMap | undefined => {
  if (!!!row?.customFilterValues?.[1]?.value) {
    return undefined;
  }

  const getFieldValue = (option: AutocompleteOption): string =>
    option?.id ?? '';

  const getFieldLabel = (option: AutocompleteOption): string =>
    option?.label ?? '';

  // const registerItemClass = getFieldValue(row.customFilterValues?.[0].value);
  const registerItemPreferredName = getFieldValue(
    row.customFilterValues?.[1].value
  );
  const selectedRelationType =
    row.customFilterValues?.[2].value || relationOptionsOptions[0];
  const relationType = getFieldValue(selectedRelationType);
  const relationTypeLabel = getFieldLabel(selectedRelationType);

  //console.log({ registerItemClass, registerItemPreferredName, relationType });

  const paramsMap = getEmptyParamsMap();

  if (relationType === '_ALL_ROLES') {
    const filter: Filter = {
      operation: 'OR',
      filters: [
        {
          operation: 'CONTAINS',
          field: 'relations.originator.label',
          value: registerItemPreferredName,
          nestedQueryEnabled: false,
        },
        {
          operation: 'CONTAINS',
          field: 'eadNode.relations.originator.label',
          value: registerItemPreferredName,
          nestedQueryEnabled: false,
        },
      ],
    };
    paramsMap.EAD_NODE_UNIT?.push(getNegationFilter(filter, !!row.negation));
  } else {
    const filter: Filter = {
      operation: 'OR',
      filters: [
        {
          operation: 'NESTED',
          path: 'relations',
          filter: {
            operation: 'AND',
            filters: [
              {
                operation: 'CONTAINS',
                field: 'relations.originator.label',
                value: registerItemPreferredName,
                nestedQueryEnabled: false,
              },
              {
                operation: 'EQ',
                field: 'relations.label',
                value: relationTypeLabel, //row.relationFilterValue?.relationRole?.label,
                nestedQueryEnabled: false,
              },
            ],
          },
        },
        {
          operation: 'NESTED',
          path: 'eadNode.relations',
          filter: {
            operation: 'AND',
            filters: [
              {
                operation: 'CONTAINS',
                field: 'eadNode.relations.originator.label',
                value: registerItemPreferredName,
                nestedQueryEnabled: false,
              },
              {
                operation: 'EQ',
                field: 'eadNode.relations.label',
                value: relationTypeLabel, //row.relationFilterValue?.relationRole?.label,
                nestedQueryEnabled: false,
              },
            ],
          },
        },
      ],
    };
    paramsMap.EAD_NODE_UNIT?.push(getNegationFilter(filter, !!row.negation));
  }

  return paramsMap;
};
